import React, { memo } from 'react'
import Shape2 from '@/assets/images/shape2.png'
import { Select } from 'antd'
interface ChildProp {
  list: any
  fieldName?: Object
  width?: number
  height?: number
  type: string
  handleSetDate: (value: string, e: any, type: string) => void
}
const SelectOption: React.FC<ChildProp> = memo(prop => {
  const {
    list = {},
    fieldName = { label: 'desc', value: 'key' },
    width = 200,
    handleSetDate,
    type,
  } = prop
  return (
    <span style={{ marginLeft: '10px' }}>
      <Select
        defaultValue=""
        style={{ width: width }}
        fieldNames={fieldName}
        options={list}
        onChange={(value, target) => {
          handleSetDate(value, target, type)
        }}
        suffixIcon={<img src={Shape2} alt="" style={{ width: '12px', height: 'auto' }}></img>}
      />
    </span>
  )
})

export default SelectOption
